import { useMutation } from '@tanstack/react-query'
import { axiosClient } from 'src/lib/axios'

const getUsers = async () => {
  try {
    const res = await axiosClient.get('user/super_user/user/')
    return res.data
  } catch (err) {
    console.error(err)
  }
}

export const useFetchGetUsers = () => useMutation(async () => await getUsers())

const createUser = async (data) => {
  const res = await axiosClient.post('user/super_user/user/', data)
  return res.data
}

export const useFetchCreateUser = () => useMutation(async (data) => await createUser(data))

const updateUser = async (id, data) => {
  const res = await axiosClient.put(`user/super_user/user/${id}`, data)
  return res.data
}

export const useFetchUpdateUser = () => useMutation(async ({ id, data }) => await updateUser(id, data))

const activeUser = async (id) => {
  const res = await axiosClient.put(`user/super_user/activate/${id}`)
  return res.data
}

export const useFetchActiveUser = () => useMutation(async (id) => await activeUser(id))

const deactivateUser = async (id) => {
  const res = await axiosClient.put(`user/super_user/deactivate/${id}`)
  return res.data
}

export const useFetchDeactivateUser = () => useMutation(async (id) => await deactivateUser(id))
